import { createFileRoute } from '@tanstack/react-router'
import { onlineManager } from '@tanstack/react-query'
import { zodResolver } from '@hookform/resolvers/zod'
import { FormProvider, useForm } from 'react-hook-form'
import { toast } from 'sonner'
import { useEffect } from 'react'
import z from 'zod/v4'
import type { GetFaqsCategoriesResponse } from '@/types/faqs'
import { queryKeys } from '@/queries/keys'
import Home from '@/pages/home'
import {
  getFaqsCategoriesQueryOptions,
  getFaqsQueryOptions,
  getFleetsQueryOptions,
} from '@/queries/query'
import { CreateBookingTransportationFormFieldSchema } from '@/schemas/booking'

export const Route = createFileRoute('/home/')({
  validateSearch: z.object({
    message: z.string().optional(),
  }),
  loader: async ({ context }) => {
    if (onlineManager.isOnline() && !context.isRestoring) {
      const reqFaqCategories = context.queryClient.ensureQueryData(
        getFaqsCategoriesQueryOptions(),
      )
      const resFaqCategories = await reqFaqCategories
      return [
        context.queryClient.ensureInfiniteQueryData(getFleetsQueryOptions()),
        reqFaqCategories,
        ...(resFaqCategories?.data?.categories?.map((category) =>
          context.queryClient.ensureInfiniteQueryData(
            getFaqsQueryOptions({ category_id: category.id, search: '' }),
          ),
        ) ?? []),
      ]
    }
    const resFaqCategories =
      context.queryClient.getQueryData<GetFaqsCategoriesResponse>(
        queryKeys.faqs.categories(),
      )
    return [
      context.queryClient.getQueryData(queryKeys.fleet.list()),
      resFaqCategories,
      ...(resFaqCategories?.data?.categories?.map((category) =>
        context.queryClient.getQueryData(
          queryKeys.faqs.list({ category_id: category.id, search: '' }),
        ),
      ) ?? []),
    ]
  },
  component: RouteComponent,
})

function RouteComponent() {
  const formMethod = useForm<CreateBookingTransportationFormFieldSchema>({
    mode: 'all',
    resolver: zodResolver(CreateBookingTransportationFormFieldSchema),
    defaultValues: {
      transportations: [],
    },
  })

  const navigate = Route.useNavigate()
  const errorMessage = Route.useSearch({
    select: (s) => s.message,
  })

  useEffect(() => {
    if (errorMessage) {
      toast.error(errorMessage)
      navigate({ replace: true, search: undefined })
    }
  }, [errorMessage])

  return (
    <FormProvider {...formMethod}>
      <Home />
    </FormProvider>
  )
}
